import { MessageTemplate } from '../models';
import store from '@/store';

import { messageTemplateQueries } from '@/queries/messageTemplate.queries';
import ApiService from '@/services/ApiService';
import UtilsService from '@/services/UtilsService';

function getAllMessageTemplates() {
  const query = messageTemplateQueries.getAll(store.state.auth.currentUser.retailer.objectId);
  return ApiService.get(UtilsService.buildFullPath(query)).then((res) => res.results);
}

function createMessageTemplate(messageTemplateData: MessageTemplate) {
  return ApiService.post('/parse/classes/messageTemplates', messageTemplateData);
}

function updateMessageTemplate(messageTemplateId: string, messageTemplateData: MessageTemplate) {
  return ApiService.put(`/parse/classes/messageTemplates/${messageTemplateId}`, messageTemplateData);
}

function deleteMessageTemplate(messageTemplateId: string) {
  return ApiService.del(`/parse/classes/messageTemplates/`, messageTemplateId);
}

export const messageTemplateService = {
  getAllMessageTemplates,
  createMessageTemplate,
  updateMessageTemplate,
  deleteMessageTemplate,
};
